import React from "react";
import Navbar from "../Navbar/Navbar";
import TopBar from "../TopBar/TopBar";
import GraduationImage from "../../assets/NewsImages/Graduation/graduationMain.jpg";
import DinnerImage from "../../assets/NewsImages/DinnerNight/dinnerNightMain.jpg";
import ElectionImage from "../../assets/NewsImages/Election/election1.jpg";
import CharityImage from "../../assets/NewsImages/CharityDrive/charityMain.jpg";
import ChocolateImage from "../../assets/NewsImages/ChocolateDay/chocolateMain.jpg";
import FieldTripImage from "../../assets/NewsImages/FieldTrip/fieldTripMain.jpg";
import Footer from "../Footer/Footer";
import "./NewsItem.scss";
import { Link, useLocation, useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";

// GRADUATION IMAGES
import Graduation1 from "../../assets/NewsImages/Graduation/grad1.jpg";
import Graduation2 from "../../assets/NewsImages/Graduation/grad2.jpg";
import Graduation3 from "../../assets/NewsImages/Graduation/grad3.jpg";
import Graduation4 from "../../assets/NewsImages/Graduation/grad4.jpg";
import Graduation5 from "../../assets/NewsImages/Graduation/grad5.jpg";
import Graduation6 from "../../assets/NewsImages/Graduation/grad6.jpg";
import Graduation7 from "../../assets/NewsImages/Graduation/grad7.jpg";
import Graduation8 from "../../assets/NewsImages/Graduation/grad8.jpg";
import Graduation9 from "../../assets/NewsImages/Graduation/grad9.jpg";
import Graduation10 from "../../assets/NewsImages/Graduation/grad10.jpg";
import Graduation11 from "../../assets/NewsImages/Graduation/grad11.jpg";
import Graduation12 from "../../assets/NewsImages/Graduation/grad12.jpg";
import Graduation13 from "../../assets/NewsImages/Graduation/grad13.jpg";
import Graduation14 from "../../assets/NewsImages/Graduation/grad14.jpg";
import Graduation15 from "../../assets/NewsImages/Graduation/grad15.jpg";
import Graduation16 from "../../assets/NewsImages/Graduation/grad16.jpg";
import Graduation17 from "../../assets/NewsImages/Graduation/grad17.jpg";
import Graduation18 from "../../assets/NewsImages/Graduation/grad18.jpg";

// TRIP IMAGES
import Trip1 from "../../assets/NewsImages/FieldTrip/trip1.jpg";
import Trip2 from "../../assets/NewsImages/FieldTrip/trip2.jpg";
import Trip3 from "../../assets/NewsImages/FieldTrip/trip3.jpg";
import Trip4 from "../../assets/NewsImages/FieldTrip/trip4.jpg";
import Trip5 from "../../assets/NewsImages/FieldTrip/trip5.jpg";
import Trip6 from "../../assets/NewsImages/FieldTrip/trip6.jpg";
import Trip7 from "../../assets/NewsImages/FieldTrip/trip7.jpg";
import Trip8 from "../../assets/NewsImages/FieldTrip/trip8.jpg";
import Trip9 from "../../assets/NewsImages/FieldTrip/trip9.jpg";
import Trip10 from "../../assets/NewsImages/FieldTrip/trip10.jpg";
import Trip11 from "../../assets/NewsImages/FieldTrip/trip11.jpg";
import Trip12 from "../../assets/NewsImages/FieldTrip/trip12.jpg";

// DINNER
import Dinner1 from "../../assets/NewsImages/DinnerNight/Dinner1.jpg";
import Dinner2 from "../../assets/NewsImages/DinnerNight/Dinner2.jpg";
import Dinner3 from "../../assets/NewsImages/DinnerNight/Dinner3.jpg";
import Dinner4 from "../../assets/NewsImages/DinnerNight/Dinner4.jpg";
import Dinner5 from "../../assets/NewsImages/DinnerNight/Dinner5.jpg";
import Dinner6 from "../../assets/NewsImages/DinnerNight/Dinner6.jpg";
import Dinner7 from "../../assets/NewsImages/DinnerNight/Dinner7.jpg";
import Dinner8 from "../../assets/NewsImages/DinnerNight/Dinner8.jpg";
import Dinner9 from "../../assets/NewsImages/DinnerNight/Dinner9.jpg";
import Dinner10 from "../../assets/NewsImages/DinnerNight/Dinner10.jpg";
import Dinner11 from "../../assets/NewsImages/DinnerNight/Dinner11.jpg";
import Dinner12 from "../../assets/NewsImages/DinnerNight/Dinner12.jpg";

// CHARITY
import Charity1 from "../../assets/NewsImages/CharityDrive/Charity1.jpg";
import Charity2 from "../../assets/NewsImages/CharityDrive/Charity2.jpg";
import Charity3 from "../../assets/NewsImages/CharityDrive/Charity3.jpg";
import Charity4 from "../../assets/NewsImages/CharityDrive/Charity4.jpg";
import Charity5 from "../../assets/NewsImages/CharityDrive/Charity5.jpg";
import Charity6 from "../../assets/NewsImages/CharityDrive/Charity6.jpg";

// CHOCOLATE DAY
import Chocolate1 from "../../assets/NewsImages/ChocolateDay/Chocolate1.jpg";
import Chocolate2 from "../../assets/NewsImages/ChocolateDay/Chocolate2.jpg";
import Chocolate3 from "../../assets/NewsImages/ChocolateDay/Chocolate3.jpg";
import Chocolate4 from "../../assets/NewsImages/ChocolateDay/Chocolate4.jpg";
import Chocolate5 from "../../assets/NewsImages/ChocolateDay/Chocolate5.jpg";
import Chocolate6 from "../../assets/NewsImages/ChocolateDay/Chocolate6.jpg";
import Chocolate7 from "../../assets/NewsImages/ChocolateDay/Chocolate7.jpg";
import Chocolate8 from "../../assets/NewsImages/ChocolateDay/Chocolate8.jpg";
import Chocolate9 from "../../assets/NewsImages/ChocolateDay/Chocolate9.jpg";
import Chocolate10 from "../../assets/NewsImages/ChocolateDay/Chocolate10.jpg";
import Chocolate11 from "../../assets/NewsImages/ChocolateDay/Chocolate11.jpg";
import Chocolate12 from "../../assets/NewsImages/ChocolateDay/Chocolate12.jpg";
import Chocolate13 from "../../assets/NewsImages/ChocolateDay/Chocolate13.jpg";
import Chocolate14 from "../../assets/NewsImages/ChocolateDay/Chocolate14.jpg";
import { BsWhatsapp } from "react-icons/bs";

const NewsItem = () => {
  const location = useLocation();
  const { slug } = useParams();

  const news = [
    {
      slug: "2023-graduation-ceremony",
      image: GraduationImage,
      date: "29th September, 2023",
      title: "GRADUATION CEREMONY",
      description:
        "The school’s graduation where learners from the Foundation Class,Reception 2 and Grade 3 Class were graduated to the next higher class",
      images: [
        Graduation1,
        Graduation2,
        Graduation3,
        Graduation4,
        Graduation5,
        Graduation6,
        Graduation7,
        Graduation8,
        Graduation9,
        Graduation10,
        Graduation11,
        Graduation12,
        Graduation13,
        Graduation14,
        Graduation15,
        Graduation16,
        Graduation17,
        Graduation18,
      ],
    },
    {
      slug: "dinner-night",
      image: DinnerImage,
      date: "28th September, 2023",
      title: "DINNER NIGHT",
      description:
        "Institutions do not exist in a vacuum. Every institution is an ‘Artificial Being’. The very existence of an institution is dependent on its stakeholders",
      images: [
        Dinner1,
        Dinner2,
        Dinner3,
        Dinner4,
        Dinner5,
        Dinner6,
        Dinner7,
        Dinner8,
        Dinner9,
        Dinner10,
        Dinner11,
        Dinner12,
      ],
    },
    {
      slug: "student-leadership-elections-2023",
      image: ElectionImage,
      date: "Friday 8th September, 2023",
      title: "STUDENT LEADERSHIP ELECTIONS 2023",
      description:
        "Student leadership is one of the most important phases of every educational institution. The student leadersserve as the official mouthpiece of the student body.",
      images: [],
    },
    {
      slug: "anell-charity-drive",
      image: CharityImage,
      date: "Wednesday 7th June, 2023",
      title: "ANELL CHARITY DRIVE",
      description:
        "As part of the school’s 2nd Year Anniversary, the school embarked on a Charity drive to the NewLifeMissionary Home at Mbroum off Suame - Magazine road to make a donation to the children’s home. ",
      images: [Charity1, Charity2, Charity3, Charity4, Charity5, Charity6],
    },
    {
      slug: "field-trip",
      image: FieldTripImage,
      date: "7th June, 2023",
      title: "FIELD TRIP",
      description:
        "As part of World’s Environmental Day and also to celebrate Green Ghana Day, our learners embarkedonanEducational trip to Council for Scientific Industrial Research at Fumesua, Kumasi.",
      images: [
        Trip1,
        Trip2,
        Trip3,
        Trip4,
        Trip5,
        Trip6,
        Trip7,
        Trip8,
        Trip9,
        Trip10,
        Trip11,
        Trip12,
      ],
    },
    {
      slug: "anell-chocolate-day",
      image: ChocolateImage,
      date: "26TH MAY, 2023",
      title: "ANELL CHOCOLATE DAY",
      description:
        "Every 14th February is set aside as National Chocolate day in Ghana. This day was observed as suchbypupilsof Anell School of Excellence right from Preschool to the Grade school level.",
      images: [
        Chocolate1,
        Chocolate2,
        Chocolate3,
        Chocolate4,
        Chocolate5,
        Chocolate6,
        Chocolate7,
        Chocolate8,
        Chocolate9,
        Chocolate10,
        Chocolate11,
        Chocolate12,
        Chocolate13,
        Chocolate14,
      ],
    },
  ];
  const [mainNews, setMainNews] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    setMainNews(news.find((newsItem) => newsItem.slug === slug));
  }, [location]);

  const selectMainNews = (news_slug) => {
    setMainNews(news.find((newsItem) => newsItem.slug === news_slug));
  };

  return (
    <div>
      <TopBar />
      <Navbar />
      <div id="news-item-section">
        <div className="main-news">
          <h1 className="news-item-title">{mainNews?.title}</h1>
          <p className="news-item-description">{mainNews?.date}</p>
          <div
            className="news-item-main-image"
            style={{
              backgroundImage: `url(${mainNews?.image})`,
              backgroundPositionX: "center",
              backgroundPositionY: "center",
              height: "500px",
              backgroundSize: "cover",
            }}
          >
            {/* <img src={mainNews?.image} alt="graduation" /> */}
          </div>
          <p className="news-item-body">
            {mainNews?.slug === "2023-graduation-ceremony" && (
              <>
                <p>
                  To culminate the event, the second edition of the school's
                  graduation took place, marking the transition of students from
                  the Foundation Class, Reception 2, and Grade 3 Class to the
                  next grade. The event showcased remarkable displays by
                  students from the Foundation class, Reception Learners, and
                  the school's Karate club. Furthermore, the science club and
                  Literacy club also delivered captivating performances.
                </p>{" "}
                <br />
                <p>
                  Mrs. Regina Asamoah-Frimpong, the former Human Resource
                  Manager of Ghana Education Service for Asokore-Mampong
                  Municipality, served as the Chairperson for this significant
                  occasion. The school had the honor of hosting Mr. Enoch Oye,
                  the Vice Principal and Head of Curriculum & Professional
                  Development, as the esteemed Guest Speaker.
                </p>{" "}
                <br />
                <p>
                  Mr. Oye's impactful speech placed a special focus on the
                  learners, leaving a lasting impression on everyone present.
                  The ceremony concluded with the conferral and presentation of
                  awards, making it a memorable event for all.
                </p>
              </>
            )}
            {mainNews?.slug === "dinner-night" && (
              <>
                <p>
                  Institutions are not isolated entities; they are intricately
                  linked to their stakeholders. They are, in essence,
                  'Artificial Beings' shaped by the collective efforts of those
                  involved. In line with our commitment to strengthen these
                  bonds, Anell School of Excellence hosted a Pre-Graduation
                  Dinner Night, a delightful evening filled with sumptuous
                  cuisine, music, and captivating performances by our Ballet
                  group and choir.
                </p>{" "}
                <br />
                <p>
                  The 2023 graduation program at Anell School marked two
                  unforgettable days of celebration and achievement. This
                  memorable dinner night brought together proud parents and
                  students, fostering an atmosphere of gratitude and reflection.
                </p>
                <br />
                <p>
                  Mrs. Ellen Antwiwaa Sarkodie, our esteemed Director, expressed
                  her deep appreciation for the school's remarkable
                  accomplishments and the unwavering support of parents, staff,
                  and management. She underscored the central message of her
                  speech: “Together, we are nurturing the leaders of tomorrow,"
                  emphasizing our collective role in shaping the future.
                </p>
                <br />
                <p>
                  Furthermore, the evening featured an impressive display by the
                  school's Computer Programmers, adding a touch of innovation to
                  the event.
                </p>
                <br />
                <p>
                  History was made as we witnessed the swearing-in of our
                  first-ever prefects, followed by an inspiring speech from our
                  Head Prefect on behalf of the team. Mr. Eric Opoku Asare, the
                  school's Administrator, introduced the elected leaders to
                  various stakeholders. Subsequently, Mr. Francis Adjei Boadi,
                  the former Principal, administered the oath of office to the
                  newly elected leaders during the school's inaugural
                  Pre-Graduation Dinner Night on September 28, 2023. The entire
                  process, from Election Orientation to Presentation and the
                  Swearing-in of the student leaders, was a captivating journey.
                </p>
                <br />
                <p>
                  The night was filled with joy and camaraderie, and we look
                  forward to welcoming you to our next event, as we celebrate
                  leadership, unity, and the promise of a bright future.
                  Together, we are nurturing the leaders of tomorrow.
                </p>
              </>
            )}
            {mainNews?.slug === "student-leadership-elections-2023" && (
              <>
                <p>
                  Student leadership stands as a pivotal phase within any
                  educational institution, as it provides students with the
                  platform to represent their peers. Recognizing the
                  significance of this, Anell School of Excellence conducted
                  student elections, guiding upper-grade learners through the
                  essential stages of the electoral process, including
                  Orientation, Vetting, Manifesto Writing and Presentation.
                </p>
                <br />
                <p>
                  The positions contested were three in number: Student Council
                  Prefect (Head Prefect), Protocol Prefect, and Sanitation
                  Prefect. Once the roles were announced, interested candidates
                  obtained nomination forms from the administration. The
                  following individuals successfully completed the vetting
                  process and competed for these positions:
                </p>
                <br />
                <p>
                  After the positions were announced, the interested candidates
                  came to pick the nomination forms fromtheadministration. These
                  were the candidates who went through the vetting process to
                  contest for the positions;
                </p>{" "}
                <br />
                <ul>
                  <li>
                    Salsabeel Borquaye Sawadogo for Student Council Prefect
                  </li>
                  <li>Kristodia Nana Aka Boakye Viadom for Protocol Prefect</li>
                  <li>Kingsley Kojo Amamoo for Protocol Prefect</li>
                  <li>Emmanuella Osei Afriyie for Sanitation Prefect</li>
                  <li>Kayla Badu Sarkodie for Sanitation Prefect</li>
                  <li>Adwoa Fobi Donkor for Sanitation Prefect</li>
                </ul>
                <br />
                <p>
                  The entire student body engaged in the electronic voting
                  system introduced by the school's management. At the
                  conclusion of the process, Salsabeel Borquaye Sawadogo,
                  Kristodia Nana Aka Boakye Yiadom, and Kayla Bad Sarkodie
                  emerged as the duly elected Student Council Prefect, Protocol
                  Prefect, and Sanitation Prefect, respectively. These elections
                  were a testament to the school's commitment to a democratic
                  leadership selection process.
                </p>
              </>
            )}
            {mainNews?.slug === "anell-charity-drive" && (
              <>
                <p>
                  As part of Anell School's 2nd Year Anniversary celebration, a
                  heartwarming charity initiative was undertaken. The school
                  organized a Charity Drive to the New Life Missionary Home,
                  located in Mbroum off Suame - Magazine road, to extend a
                  helping hand to the children residing there.
                </p>
                <br />
                <p>
                  Parents and guardians of Anell School were given the
                  opportunity to contribute to this noble cause. The
                  overwhelming support and generosity from Anell's parents were
                  truly remarkable, and the school expressed its heartfelt
                  appreciation for their kindness.
                </p>
                <br />
                <p>
                  Before the learners set out on this charitable mission, they
                  received guidance on the importance of helping those in need
                  and the less privileged in society. The instructor emphasized
                  several key points:
                </p>
                <br />
                <ul>
                  <li>
                    Charity drives hold the primary benefit of alleviating
                    suffering and improving the lives of those in need by
                    providing essential support, including food, clothing, and
                    medical care.
                  </li>
                  <li>
                    Participation in charity drives fosters empathy and
                    compassion, allowing learners to better understand the
                    challenges people face and increasing their willingness to
                    assist.
                  </li>
                  <li>
                    Engaging in charity drives empowers students to make a
                    significant impact, regardless of their financial means,
                    highlighting the collective strength of small contributions.
                  </li>
                  <li>
                    Compassionate interactions with less privileged individuals
                    can provide them with a sense of hope and support,
                    positively affecting their emotional well-being. This
                    experience aims to instill empathy in our children.
                  </li>
                </ul>{" "}
                <br />
                <p>
                  Mr. Philips Yeboah Pimpong, the Head of Academics, led the
                  donation team to the New Life Missionary Home. He introduced
                  his team to the home's leadership and explained their purpose
                  for making the donation. He stated, "Anell School is
                  conducting this drive as part of its 2nd Anniversary
                  celebration, and we chose this location because it is unique
                  among children's homes."
                </p>{" "}
                <br />
                <p>
                  After the donations were presented, Mrs. Ellen Antwiwaa
                  Sarkodie, the Director of Anell School, announced that the
                  school would annually organize a charity drive as part of its
                  commitment to spreading joy and instilling a spirit of
                  generosity in the learners.
                </p>
                <br />
                <p>
                  This charitable endeavor provided an eye-opening experience
                  for the pupils, allowing them to glimpse the challenges faced
                  by others and reinforcing the importance of giving back.
                </p>
              </>
            )}
            {mainNews?.slug === "field-trip" && (
              <>
                <p>
                  As part of World’s Environmental Day and also to celebrate
                  Green Ghana Day, our learners embarked on an Educational trip
                  to Council for Scientific Industrial Research at Fumesua,
                  Kumasi. There, they went to the various research centres such
                  as the FORESTRY RESEARCH INSTITUTE & CROPS RESEARCH
                  INSTITUTES.
                </p>{" "}
                <br />
                <p>
                  The visiting team from Anell School of Excellence, led by Mr.
                  Philips Pimpong, Head of Academics, and accompanied by Mr.
                  Joel Afram Saah, Mr. Emmanuel Twumasi, Mr. Joseph Boateng, Mr.
                  Phinehas Agyekum, Miss. Agnes Osei Bonsu, and Mr. Edward Osei
                  Bonsu, joined students from Reception 2 to Grade 4.
                </p>
                <br />
                <p>
                  The educational tour took them to several fascinating places
                  within CSIR, including the Nursery, Furniture and Wood Testing
                  Centre, Seed Department, the Cottage, and ultimately, the Rice
                  Field and Irrigation Farm. This trip proved to be both
                  informative and entertaining, offering our learners a glimpse
                  into the world of scientific research and innovation.
                </p>
                <br />
                <p>
                  Their interaction with scientists, researchers, and engineers
                  at CSIR left a lasting impression on the young minds, igniting
                  their passion for careers in science and technology.
                  Witnessing the practical applications of STEM (Science,
                  Technology, Engineering, and Mathematics) fields was highly
                  motivating.
                </p>
                <br />
                <p>
                  CSIR's research focus on environmental conservation and
                  industrial development resonated with our students, as they
                  observed how science and technology can address critical
                  global issues such as climate change, pollution, and
                  sustainable development. This experience provided a bridge
                  between classroom learning and real-world applications,
                  evident in the excitement on the faces of these young learners
                  as they connected academic knowledge to practical scenarios.
                </p>
              </>
            )}
            {mainNews?.slug === "anell-chocolate-day" && (
              <>
                <p>
                  Each year, on the 14th of February, Ghana designates it as
                  National Chocolate Day. This special occasion was commemorated
                  by students from Anell School of Excellence, spanning from the
                  preschool to the grade school levels. Our students delved into
                  the global history of cocoa, tracing its journey to Ghana and
                  the nation's ascent as the leading producer of this delectable
                  commodity. Additionally, the students had the unique
                  opportunity to participate in a hands-on learning experience,
                  during which they discovered the art of crafting chocolate.
                  Skilled instructors guided each class in creating their very
                  own chocolate treats, using a mixture of ingredients like
                  vanilla, coconut oil, sugar, salt, and cocoa powder.
                </p>
                <br />
                <p>
                  This day's festivities also fostered social interaction among
                  the students, encouraging them to share chocolate goodies and
                  engage in activities centered around this beloved treat. It
                  was a truly fantastic experience!
                </p>
              </>
            )}
          </p>
          <div className="event-images">
            {mainNews?.images?.map((image, index) => (
              <div key={index} className="event-image">
                <img src={image} alt="" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
        <div className="recent-posts">
          <h2 className="recent-posts-title">Recent Posts</h2>
          <ul className="recent-posts-list">
            {news.map((newsItem, index) => (
              <li
                onClick={() => selectMainNews(newsItem.slug)}
                key={index}
                className="recent-post"
              >
                <Link to={`/news-events/news/${newsItem.slug}`}>
                  {newsItem.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Link
        to="https://wa.me/2330504828824?text="
        target="_blank"
        id="whatsapp-icon"
      >
        <BsWhatsapp />
      </Link>
      <Footer />
    </div>
  );
};

export default NewsItem;
